import React from 'react';
import { Typography } from 'antd';
import styled from 'styled-components';

import { MpSection } from 'shared/ui/MpSection';

const SectionStyled = styled(MpSection)`
	text-align: center;
`;

const StatusCodeStyled = styled(Typography.Text)`
	font-weight: bold;
	font-size: 128px;
`;

export const AccessDenied: React.FC = () => (
	<SectionStyled>
		<StatusCodeStyled>403</StatusCodeStyled>
		<Typography.Title>Доступ запрещен</Typography.Title>
		<Typography.Paragraph type='secondary'>
			Недостаточно прав для доступа на запрашиваемую страницу
		</Typography.Paragraph>
	</SectionStyled>
);
